<template>
  <!--购买课程-->
  <div class="box">
    <div class="order-top" style="padding-top:20px">
      <van-cell-group>
        <!--<van-cell title="订单信息" value style="font-size:14px;font-weight:600" />-->
        <!--<van-cell title="联系人" :value="row.user_data.name" />-->
        <!--<van-cell title="联系电话" :value="row.user_data.phone" />-->
      </van-cell-group>
    </div>
    <div
      class="order-course"
      style="width:7.1rem;margin:0 auto;background:#fff;border-radius:0.2rem;overflow: hidden"
    >
      <van-cell-group>
        <van-cell title="课程信息" value style="font-size:14px;font-weight:600" />
      </van-cell-group>

      <div class="course-info-box">
        <div class="course-img">
          <img :src="row.course_data.pic_url" alt />
        </div>
        <div class="course-info">
          <p class="info-title">{{ row.course_data.title }}</p>
          <p class="info-main">视频 {{row.course_data.video_count}}</p>
          <div class="info-bottom">
            <span class="course-price">¥{{row.course_data.price}}</span>
            <span class="course-day">有效期 {{row.course_data.pay_days}}天</span>
          </div>
        </div>
      </div>
    </div>
    <div class="order-pay-btn">
      <!--<div class="card-pay">激活卡开通</div>-->
      <div class="online-pay" @click="onPay">在线支付开通</div>
    </div>
    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    <PayDialog
      :show="payDialogShow"
      scene="course"
      :ids="orderIds"
      @onPayError="onPayError"
      @onPaySuccess="onPaySuccess"
      @onPayClose="onPayClose"
    />
  </div>
</template>
<style scoped>
.card-pay {
  width: 160px;
  height: 44px;
  background: #ffffff;
  border-radius: 22px;
  border: 1px solid #000000;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 44px;
  text-align: center;
}
.online-pay {
  width: 160px;
  height: 44px;
  background: linear-gradient(90deg, #fec835 0%, #ffad19 100%);
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  margin-top: 40px;
}
.order-pay-btn {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 120px;
}
.info-bottom {
  display: flex;
  justify-content: space-between;
  height: 20px;
}
.course-price {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ff4768;
  line-height: 20px;
  display: block;
}
.course-day {
  height: 20px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  display: block;
}
.info-main {
  height: 15px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 15px;
}
.info-title {
  width: 100%;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 20px;
  height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.course-info {
  flex: 1;
  margin-left: 10px;
}
.course-img img {
  width: 1.1rem;
  height: 1.1rem;

  object-fit: cover;
}
.course-img {
  width: 1.1rem;
  height: 1.1rem;
  background: #ccc;
}
.course-info-box {
  display: flex;
  justify-content: space-between;
  padding: 0 16px 20px 16px;
}
.order-course >>> .van-cell-group {
  margin: 0 !important;
}
.order-course {
  margin-top: 20px;
}
.box {
  /*margin-bottom: 1.5rem;*/
  background: #f8f8f8;
  height: 100%;
}
.box >>> .van-tabs__line {
  background: #00b388;
}
</style>
<script>
import Vue from "vue";
import { Toast, Cell, CellGroup } from "vant";
import LoginDialog from "@/components/LoginDialog.vue";
import PayDialog from "@/components/PayDialog.vue";

Vue.use(Toast)
  .use(Cell)
  .use(CellGroup);
export default {
  name: "CourseOrderCheck",
  components: { LoginDialog, PayDialog },
  data: function() {
    return {
      loginShow: false,
      payDialogShow: false,
      orderIds: [0],
      course_id: 0,
      row: {
        user_data: {
          name: "",
          phone: ""
        },
        course_data: {}
      }
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "购买课程";
    that.course_id = this.$route.query.id;
    that.getOrdetForm();
  },
  watch: {},
  destroyed() {},
  methods: {
    getOrdetForm() {
      let that = this;
      that.$api.get(
        "/api/course/orderForm",
        { id: that.course_id },
        res => {
          that.row = res.data;
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            } else {
              // Toast(res.msg);
              this.loginShow = true;
            }
          }
          Toast(res.msg);
        }
      );
    },

    onPay() {
      let that = this;
      let form = {
        course_id: that.row.course_data.id,
        name: that.row.user_data.name,
        phone: that.row.user_data.phone,
        pay_price: that.row.course_data.price,
        pay_days: that.row.course_data.pay_days
      };
      that.$api.post(
        "/api/course/orderadd",
        form,
        res => {
          console.log(res);
          that.orderIds = res.data.ids;
          that.payDialogShow = true;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.getOrdetForm();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onPayError(res) {
      let that = this;
      console.log("onPayError 支付失败", res);
      that.payDialogShow = false;
      localStorage.setItem("active", 1);
      rbLink({ name: "MyCourseList" });
      // that.$toast(res.res);
    },
    onPaySuccess() {
      let that = this;
      console.log("onPaySuccess 支付成功");
      Toast.success("支付成功");
      that.payDialogShow = false;
      localStorage.setItem("active", 2);
      rbLink({ name: "MyCourseList" });
      
      // that.fetch();
    },
    onPayClose() {
      let that = this;
      console.log("onPayClose 支付关闭");
      that.payDialogShow = false;
      localStorage.setItem("active", 1);
      rbLink({ name: "MyCourseList" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// CourseOrderCheck.vue?1fa9648c